export interface Avatar {
  initials: string;
  bgColor: string;
  image: unknown | null;
}
